// extracted by mini-css-extract-plugin
export default {"button":"buttonDesign_button__wNM-d"};